import { apiPost, apiGet, apiDelete } from '../utils/api'

export function getAgGridViewsAPI(section) {
  return apiGet(`mgmt/gridview/list?start=0&limit=0&section=${section}`)
}

export function getAgGridViewByIdAPI(viewId) {
  return apiGet(`mgmt/gridview/${viewId}`)
}

export function saveOrUpdateAgGridViewAPI(view) {
  return apiPost(`mgmt/gridview`, view)
}

export function deleteAgGridViewAPI(viewId) {
  return apiDelete(`mgmt/gridview/${viewId}`)
}



// WEBPACK FOOTER //
// ./src/api/ag-grid-views.js